/**
 * @file  functions/customer.ts
 * @description  function library for the rates api
 *
 * @author dlima (dlima-electron)
 *
 */
import * as api from '../index';
import { Customer } from './customer.model';

/**
 * sets the customer
 * @param data the customer document
 */
const setCustomer = async (data: Customer): Promise<Customer> => {
  const { post } = api;
  const result: Customer = await post<Customer>('customer', data);
  return result;
};

const updateCustomer = async (data: Customer): Promise<Customer> => {
  const { put } = api;
  const result: Customer = await put<Customer>(`customer/${data.id}`, data);
  return result;
};

export const saveCustomer = async (data: Customer): Promise<Customer> => {
  if (data.id) {
    return updateCustomer(data);
  }

  return setCustomer(data);
};

export const getCustomer = async (id: string): Promise<Customer> => {
  const { get } = api;
  const result: Customer = await get<Customer>(`customer/${id}`);
  return result;
};
